<template>
  <div style="text-align: center;">
    <el-form :model="formData" label-width="100px">
      <el-form-item label="日期">
        <el-select
            v-model="formData.day"
            style="width: 200px;height: 40px"
            placeholder="选择日期">
          <el-option
              v-for="item in days"
              :key="item"
              :label="item.toString()"
              :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-time-picker
            v-model="formData.freshTime"
            style="width: 200px;height: 40px"
            value-format="HH:mm:ss"
            placeholder="选择时间">
        </el-time-picker>
      </el-form-item>
    </el-form>
    <text>考勤将于每月<span class="highlight">{{formData.day}}</span>日<span class="highlight">{{formData.freshTime}}</span>自动确认</text>
  </div>

  <div style="margin-top: 30px;text-align: center">
    <el-button type="primary" @click="save">保存</el-button>
  </div>
</template>

<script>

export default {
  name: "AttendanceAutoConfirm.vue",
  inject: ['$fn'],
  data() {
    return {
      formData: {},
      days:Array.from({length: 31}, (_, i) => i + 1)

    }
  },
  methods: {
    async getTime() {
      this.formData = await this.$http('attendanceSettingService.getAttendanceAutoConfirm');
    },
    async save() {
      this.formData = await this.$http('attendanceSettingService.editAttendanceAutoConfirm',this.formData);
      this.$message.success("保存成功");
      this.$fn.search();
      this.$fn.closeWindow();
    }

  },
  mounted() {
    this.getTime()
  }
}
</script>

<style scoped>

.highlight {
  color: #ff0000;
  font-weight: bold;
}

</style>